<template>
    <div class="row">
        <div class="col d-flex justify-content-end">
            <b-form-group label="Export File" class="mb-0 pb-2">
                <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                    <b-button variant="success" size="sm" @click="exportExcel()">
                        <div class="circle-loading" v-if="load.isLoading"></div>
                        <div v-else>excel</div>
                    </b-button>
                    <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                </div>
            </b-form-group>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { exportTransaction } from "@/axios/shop.js"
import fileDownload from 'js-file-download';
const DATE_NOW = moment().format("YYYY-MM-DD")

export default {
    props:{
        load: Object,
        role: String,
        fileName: String
    },
    methods:{
        exportExcel(){
            this.load.isLoading = true;
            exportTransaction(this.role).then( response => {
                fileDownload(response, `${this.fileName}-${DATE_NOW}.xlsx`);
                this.load.isLoading = false;
            })
        },
    }
}
</script>